import { render, staticRenderFns } from "./VinculacionExitosa.vue?vue&type=template&id=6dd836c4"
import script from "./VinculacionExitosa.vue?vue&type=script&setup=true&lang=js"
export * from "./VinculacionExitosa.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports